import ControlProps from '../../../mixins/ControlProps';
import { NumberInputProperty } from '../enums';
import InputProps from '../../../shared/input/mixins/InputProps';
import { InputProperty } from '../../../shared/input/enums';

const NumberInputProps = {
  props: {
    ...ControlProps.props,
    [NumberInputProperty.IsLoading]: InputProps.props[InputProperty.IsLoading],
    [NumberInputProperty.Max]: InputProps.props[InputProperty.MaxNumber],
    [NumberInputProperty.Min]: InputProps.props[InputProperty.MinNumber],
    [NumberInputProperty.Step]: InputProps.props[InputProperty.Step],
    [NumberInputProperty.FillType]: InputProps.props[InputProperty.FillType],
    [NumberInputProperty.HasThousandSeparator]: {
      default: false,
      type: Boolean,
    },
  },
};

export default NumberInputProps;
